import React, { useEffect } from "react";
import { StakesCard } from "./Stakes.styled";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { withdrawStake } from "../../feature/stake/StakeActions";
import ReactLoading from "react-loading";
import { FormError } from "../Auth.styled";
import { clearMessage } from "../../feature/message/messageSlice";
import { clearInputError } from "../../feature/inputError/inputErrorSlice";

const WithdrawStake = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = location.state !== null && location.state.data;

  const { withdrawStakeLoading } = useSelector((state) => state.stake);
  const { inputError } = useSelector((state) => state.inputError);

  useEffect(() => {
    location.state === null && navigate("/stakes");
  }, [location.state, navigate]);

  useEffect(() => {
    dispatch(clearMessage());
    dispatch(clearInputError);
  }, [dispatch]);

  return (
    <div style={{ marginInline: "15px" }}>
      <StakesCard>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div>
            <div style={{ marginBottom: "5px" }}>
              {data.stake_plan_set.staking_duration} Days Staking
            </div>
          </div>
          <div>
            <div>Days Running:</div>
            <div style={{ color: "#C597F8", marginBottom: "5px" }}>
              {Math.floor(
                (new Date().getTime() - new Date(data.date_created).getTime()) /
                  (1000 * 3600 * 24)
              )}{" "}
              Day
              {Math.floor(
                (new Date().getTime() - new Date(data.date_created).getTime()) /
                  (1000 * 3600 * 24)
              ) > 0 && "s"}{" "}
              {data.is_completed && "(completed)"}
            </div>
          </div>
          <div>
            <div>Earnings In Days:</div>
            <div style={{ color: "#C597F8", marginBottom: "5px" }}>
              {(
                data.return_on_stake / data.stake_plan_set.staking_duration
              ).toFixed(2)}{" "}
              TRX
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div>Total:</div>
            <div style={{ color: "#C597F8", marginInlineStart: "5px" }}>
              {(
                (data.amount * parseInt(data.stake_plan_set.percentage)) / 100 +
                parseInt(data.amount)
              ).toFixed(2)}{" "}
              TRX
            </div>
          </div>
        </div>

        {/* <button style={{ width: "30%", height: "40px", marginBlock: "auto" }}>
          Restake
        </button> */}
      </StakesCard>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "20px",
          marginBlockStart: "40px",
          border: "1px solid #7B36EE",
        }}
      >
        <span>Amount to withdraw:</span> <span>{data.amount} TRX</span>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBlock: "20px",
        }}
      >
        {(
          (data.amount * parseInt(data.stake_plan_set.percentage)) / 100 +
          parseInt(data.amount)
        ).toFixed(2)}{" "}
        TRX Will be added to your balance
      </div>
      <button
        style={{
          height: "40px",
          width: "50%",
          display: "flex",
          marginInline: "auto",
        }}
        disabled={withdrawStakeLoading}
        onClick={() =>
          dispatch(withdrawStake({ data }))
            .unwrap()
            .then(() => navigate("/stakes"))
        }
      >
        {withdrawStakeLoading ? (
          <ReactLoading
            type={"spinningBubbles"}
            height={"20px"}
            width={"20px"}
          />
        ) : (
          "Withdraw"
        )}
      </button>

      <FormError>
        {inputError !== undefined
          ? inputError[0]
            ? inputError[0]
            : null
          : null}
      </FormError>
    </div>
  );
};

export default WithdrawStake;
